import React, { useCallback } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { RotateIcon } from '@rbilabs/components-library/build/components/rotate-icon';

import { DisplayToggleProps } from './types';

function DisplayToggle({ className, collapsed, onClick, onCollapseKeyPress }: DisplayToggleProps) {
  const expanded = !collapsed;

  const handleCollapseKeyPress = useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      const COLLAPSE_KEY_EVENTS = ['Enter', ' '];
      if (COLLAPSE_KEY_EVENTS.includes(event.key)) {
        onCollapseKeyPress();
      }
    },
    [onCollapseKeyPress]
  );

  return (
    <div
      className={className}
      data-testid="display-toggle-payment-method"
      aria-label="Toggle to select payment method"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyPress={handleCollapseKeyPress}
      aria-expanded={expanded}
    >
      <RotateIcon active={expanded}>
        <Icon icon="select" color="icon-form-input-action" width="24px" aria-hidden />
      </RotateIcon>
    </div>
  );
}

export default DisplayToggle;
